import React from 'react';
import { RegularButton, Typography } from 'fronton-react';
import { useTranslation } from 'react-i18next';
import {
  MeasurementBannerTextWrapper,
  MeasurementBannersWrapper,
  MeasurementBannerContainer,
} from './styles';

type TProps = {
  priceMin: number | undefined;
  serviceURL: string;
  serviceName: string;
  onClickCallMaster?: () => void;
};

export const MeasurementBanner = ({ priceMin, serviceURL, serviceName, onClickCallMaster }: TProps) => {
  const { t } = useTranslation();

  const handleClickCallMaster = () => {
    onClickCallMaster?.();
    window.open(serviceURL, '_blank', 'noopener noreferrer');
  };

  // расскоментить когда появится стабильная инструкция
  // const handleClickOpenInstruction = () => {
  //   window.open(instructionURL, '_blank', 'noopener noreferrer');
  // };

  const price = typeof priceMin === 'number' ? priceMin : 0;

  return (
    <MeasurementBannersWrapper data-testid="measurement-banner">
      <MeasurementBannerContainer>
        <MeasurementBannerTextWrapper>
          <Typography size="overline" variant="s">
            {t('measurementBanner.header')}
          </Typography>
          <Typography variant="s" color="text-primary" size="body_long" data-testid="service-name-title">
            {serviceName}
          </Typography>
        </MeasurementBannerTextWrapper>

        <RegularButton
          data-testid="call-master-button"
          invert
          rounded
          size="s"
          variant="primary"
          onClick={handleClickCallMaster}>
          Вызвать мастера от {price} ₽
        </RegularButton>
      </MeasurementBannerContainer>

      {/* расскоментировать, когда появится стабильная инструкция */}
      {/* isShowMeasurementBanner и instructionURL можно прокидывать в пропсах */}
      {/*       <SelfMeasurementBannerContainer notAlone={!!isShowMeasurementBanner}>
        <MeasurementBannerTextWrapper>
          <Typography size="overline" variant="s">
            Самостоятельный замер
          </Typography>
          <Typography variant="s" color="text-primary" size="body_long" data-testid="service-name-title">
            Простая инструкция поможет измерить комнату для&nbsp;расчета
          </Typography>
        </MeasurementBannerTextWrapper>

        <RegularButton
          data-testid="open-self-measurement-instructions-button"
          invert
          rounded
          size="m"
          variant="primary"
          onClick={handleClickOpenInstruction}>
          Открыть инструкцию
        </RegularButton>
      </SelfMeasurementBannerContainer> */}
    </MeasurementBannersWrapper>
  );
};
